import { Brain, Target, Zap } from "lucide-react";
import { useTranslation } from "react-i18next";

// DEPRECATED: 2026-01-19
const MainBenefits = () => {
  const { t } = useTranslation();

  const benefits = [
    {
      icon: Brain,
      titleKey: "mainBenefits.benefits.anxiety.title",
      descriptionKey: "mainBenefits.benefits.anxiety.description"
    },
    {
      icon: Target,
      titleKey: "mainBenefits.benefits.habits.title",
      descriptionKey: "mainBenefits.benefits.habits.description"
    },
    {
      icon: Zap,
      titleKey: "mainBenefits.benefits.sleep.title",
      descriptionKey: "mainBenefits.benefits.sleep.description"
    }
  ];

  return (
    <section className="pt-4 pb-12 bg-slate-50">
      <div className="max-w-7xl mx-auto px-0 sm:px-2 lg:px-4">
        <div className="text-center mb-8 mx-auto max-w-2xl px-4">
          <div className="text-lg md:text-2xl mb-4 px-4">{t('mainBenefits.intro.title')}</div>
          <h2 className="text-2xl md:text-4xl font-semibold text-slate-900 mb-4 md:mb-8 leading-normal md:leading-snug">
            <div>{t('mainBenefits.intro.subtitle')}</div>
            <div className="text-transparent bg-clip-text bg-sky-500">
              {t('mainBenefits.intro.highlight')}
            </div>
          </h2>
        </div>

        <div className="sm:mb-4">
          <img
            alt="Clarymind Cover"
            className="w-full sm:rounded-xl sm:shadow-lg"
            src={t('assets.cover')}
          />
        </div>

        {/* <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className="px-6 pt-8 pb-6 flex flex-col items-center rounded-xl bg-white shadow-lg border border-slate-200"
            >
              <div className="mb-6 flex justify-center">
                <div className="w-16 h-16 bg-gradient-to-br from-teal-500 via-sky-500 to-violet-500 rounded-xl flex items-center justify-center">
                  <benefit.icon className="w-8 h-8 text-white" />
                </div>
              </div>
              <h3 className="text-center text-xl md:text-2xl font-semibold text-slate-900 mb-4">
                {t(benefit.titleKey)}
              </h3>
              <p className="text-slate-600 leading-relaxed text-base text-left mx-auto mb-2">
                {t(benefit.descriptionKey)}
              </p>
            </div>
          ))}
        </div> */}
      </div>
    </section>
  );
};

export default MainBenefits;
